export enum InputType {
  text = 'text',
  date = 'date',
  select = 'select',
  number = 'number',
  float = 'float',
}
